import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import "../../form-pages/AddressDetails.css";

export default function MobileModal({ onContinue, onClose }) {
  return (
    <div className="address-modal-overlay" onClick={onClose}>
      <div className="address-modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="address-modal-header">
          <span
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "36px",
              height: "36px",
              borderRadius: "50%",
              backgroundColor: "var(--ycm-orange)",
              flexShrink: 0,
              marginRight: "8px",
            }}
          >
            <FontAwesomeIcon
              icon={faPhone}
              style={{ color: "#fff", fontSize: "16px" }}
            />
          </span>
          <span className="address-modal-title">
            Don't miss important updates
          </span>
        </div>

        <p className="address-modal-description">
          We will use this information to keep you updated on your claim.
        </p>

        <div className="address-modal-actions">
          <button className="modal-btn-primary" onClick={onClose}>
            Add mobile number
          </button>
          <button className="modal-btn-secondary" onClick={onContinue}>
            Continue anyway
          </button>
        </div>
      </div>
    </div>
  );
}
